import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.svg'
import _imports_1 from '@/assets/img/icons/save-black.svg'


const _hoisted_1 = { class: "flex gap-16" }
const _hoisted_2 = { class: "w-1/3 flex-shrink-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-1/3 mb-3"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl text-blue-900 mb-3 font-semibold" }, "Buat Proyek Baru", -1)
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "flex gap-4" }
const _hoisted_7 = { class: "w-1/2" }
const _hoisted_8 = { class: "w-1/2" }
const _hoisted_9 = { class: "relative h-16" }
const _hoisted_10 = { class: "bg-white border-t p-2 left-0 flex gap-3 justify-end fixed bottom-0 w-full" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_label = _resolveComponent("input-label")!
  const _component_assessment_list = _resolveComponent("assessment-list")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_input_label, {
              label: "Nama Proyek",
              isRequired: true
            }),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.projectName) = $event)),
              class: "p-2 border rounded w-full"
            }, null, 512), [
              [_vModelText, _ctx.projectName]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_input_label, {
                label: "Tanggal Mulai Proyek",
                isRequired: true
              }),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.startedAt) = $event)),
                class: "p-2 border rounded w-full"
              }, null, 512), [
                [_vModelText, _ctx.startedAt]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_input_label, {
                label: "Tanggal Selesai Proyek",
                isRequired: true
              }),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.endedAt) = $event)),
                class: "p-2 border rounded w-full"
              }, null, 512), [
                [_vModelText, _ctx.endedAt]
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_assessment_list, {
        data: _ctx.assessments,
        selectedAssessment: _ctx.selectedAssessment,
        onSetSelectedAssessment: _ctx.setSelectedAssessment
      }, null, 8, ["data", "selectedAssessment", "onSetSelectedAssessment"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_router_link, {
          to: "/admin/home",
          class: "px-4 py-2 bg-transparent border-1 border-gray-300 rounded text-blue-900 text-sm leading-6 font-semibold flex items-center gap-3"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Batal ")
          ]),
          _: 1
        }),
        _createElementVNode("button", {
          disabled: !_ctx.canSubmit,
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.createProject && _ctx.createProject(...args))),
          class: _normalizeClass(["px-4 py-2 rounded text-black leading-6 text-sm font-semibold flex items-center gap-3", 
          _ctx.canSubmit ? 'bg-yellow-400 opacity-1' : 'bg-gray-400 opacity-30'
        ])
        }, [
          _hoisted_12,
          _createTextVNode(" Simpan ")
        ], 10, _hoisted_11)
      ])
    ])
  ], 64))
}